
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 20a10 10 0 1110-10 10.011 10.011 0 01-10 10zm-2.5-8.25a.5.5 0 00-.5.5V13a2 2 0 002 2v.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V15a2 2 0 002-2v-.81a1.993 1.993 0 00-.73-1.54L8.84 7.82a.221.221 0 01-.09-.19v-.88h2.5v1a.5.5 0 00.5.5h.75a.5.5 0 00.5-.5V7a2 2 0 00-2-2v-.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V5a2 2 0 00-2 2v.81a1.992 1.992 0 00.73 1.54l3.43 2.83a.22.22 0 01.09.19v.88h-2.5v-1a.5.5 0 00-.5-.5H7.5z","fill":"#767679"}})])
          )
        }
      }
    